/**
 * 取 object 的某些属性，作为新对象
 * @param {*} object 对象
 * @param {string | string[]} keys 要取的属性，字符串数组，或以 , 号分割的字符串
 *
 * @return object 新生成的对象
 */
export function slice(object, keys) {
  if (object == null) {
    return {}
  }

  const keyList = keys instanceof Array ? keys : keys.split(',')
  const result = {}
  for (const n in keyList) {
    if (keyList.hasOwnProperty(n)) {
      const key = keyList[n]
      const val = object[key]
      val !== undefined && (result[key] = val)
    }
  }
  return result
}

/**
 * 排除对象中的某些属性，返回新对象
 * @param {*} object 对象
 * @param {string | string[]} keys 要排除的属性，字符串数组，或以 , 号分割的字符串
 */
export function except(object, keys) {
  if (object == null) {
    return {}
  }

  const keyList = keys instanceof Array ? keys : keys.split(',')
  const result = { ...object }
  for (const key of keyList) {
    delete result[key]
  }
  return result
}

/**
 * 清除对象中的某些值，返回新对象
 * @param {*} object 对象
 * @param {any[]} cleanList 要清除的值
 */
export function clean(object, cleanList = [null, undefined, '']) {
  if (object == null) {
    return {}
  }

  const result = {}
  for (const key in object) {
    if (object.hasOwnProperty(key)) {
      const val = object[key]
      cleanList.includes(val) || (result[key] = val)
    }
  }
  return result
}

export function arrayValues(object, fromIndex, toIndex) {
  const result = []
  for (let i = fromIndex; i < toIndex; i++) {
    if (i in object) {
      result.push(object[i])
    }
  }
  return result
}



// WEBPACK FOOTER //
// ./src/util/object.js